import React from "react";
import "./Header.css";
import headerLogoImg from "../images/expense.png";
import likePngImg from "../images/like.png";

const Header = () => {
  return (
    <div className="header__container flex__center">
      <div className="box__around flex__center">
        <div className="left__section flex__center">
          <img src={headerLogoImg} alt="img" className="header__logo" />
          <div className="header__title">Expense Tracker</div>
        </div>
        <div className="right__section flex__center">
          <img src={likePngImg} alt="like" className="like__img" />
        </div>
      </div>
    </div>
  );
};

export default Header;
